import React, { useEffect, useState } from "react";
import { TextField } from "@mui/material";

export function ScrubbableNumber({
  defaultValue,
  onChange,
  onScrub,
  onBlur,
}: {
  defaultValue: number;
  onChange: (newValue: number) => void;
  onScrub: (dValue: number) => void;
  onBlur: (currentValue: number) => void;
}) {
  const [value, setValue] = useState<string>(defaultValue.toString() ?? "");
  const [grabbed, setGrabbed] = useState<boolean>(false);

  useEffect(() => {
    function onMouseMove(e: MouseEvent) {
      const newValue = e.movementX / 2;
      setValue((v) => {
        const numericValue = Number.parseFloat(v);
        if (Number.isFinite(numericValue)) {
          return (numericValue + newValue).toString();
        } else {
          return newValue.toString();
        }
      });
      onScrub(newValue);
    }

    function ungrab() {
      setGrabbed(false);
    }

    if (grabbed) {
      document.body.addEventListener("mousemove", onMouseMove);
      document.body.addEventListener("mouseup", ungrab);
      document.body.addEventListener("mouseleave", ungrab);
    } else {
      document.body.removeEventListener("mousemove", onMouseMove);
    }

    return () => {
      document.body.removeEventListener("mousemove", onMouseMove);
      document.body.removeEventListener("mouseup", ungrab);
      document.body.removeEventListener("mouseleave", ungrab);
    };
  }, [grabbed]);

  return (
    <TextField
      inputProps={{
        sx: {
          "&:hover": {
            cursor: "ew-resize",
          },
        },
        style: { textDecoration: "underline dotted" },
      }}
      onBlur={(e) => {
        const newValue = Number.parseFloat(e.target.value);
        if (Number.isFinite(newValue)) {
          onBlur(newValue);
        } else {
          setValue("");
          onChange(0);
        }
      }}
      onChange={(e) => {
        setValue(e.target.value);
        const newValue = Number.parseFloat(e.target.value);
        if (Number.isFinite(newValue)) {
          onChange(newValue);
        } else {
          onChange(0);
        }
      }}
      onMouseDown={() => {
        setGrabbed(true);
      }}
      onMouseUp={() => {
        setGrabbed(false);
      }}
      value={value}
    />
  );
}
